import { apiService } from './api'


class BreedService {
  async getBreeds(params?: any) {
    const response = await apiService.api.get('/admin/breeds', { params })
    return response.data
  }

  async getAllBreeds() {
    const response = await apiService.api.get('/admin/breeds/all?include=pets')
    return response.data
  }

  async getBreedsByAnimalType(animalTypeId: number) {
    const response = await apiService.api.get(`/admin/animal-types/${animalTypeId}/breeds`)
    return response.data
  }

  async getBreed(id: number | string) {
    const response = await apiService.api.get(`/admin/breeds/${id}`)
    return response.data
  }

  async createBreed(data: any) {
    const response = await apiService.api.post('/admin/breeds', data)
    return response.data
  }

  async updateBreed(id: number | string, data: any) {
    const response = await apiService.api.put(`/admin/breeds/${id}`, data)
    return response.data
  }

  async deleteBreed(id: number | string) {
    await apiService.api.delete(`/admin/breeds/${id}`)
  }

  async getBreedStats() {
    const response = await apiService.api.get('/admin/breeds/stats')
    return response.data
  }
}

export const breedService = new BreedService()
export default breedService